import API from "@/API";

export const executeValidBooks = async (bookGroup, is_multi_validatable) => {
  try {
    // ブックの複数有効化ができない商材は単発validAPI
    if (!is_multi_validatable) {
      for (let i = 0; i < bookGroup.books.length; i++) {
        await API.validBook(bookGroup.books[i].id);
      }
    } else {
      await API.validBooks(bookGroup.books);
    }
  } catch (err) {
    throw err;
  }
};
